/** Canonical production origin and brand for SEO output. */
export const SITE_URL = "https://poonamkapur.com";
export const BRAND_NAME = "Poonam Kapur Healthy Kitchen";
export const canonicalUrl = (path = "/") => `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
